<template>
  <div class="p-8" v-if="loading">
    <loading />
  </div>
  <div class="p-6 stack" v-else>
    <input-text
      type="number"
      :label="$t('targets.target_value')"
      :value="formData.target"
      @update-value="updateForm('target', $event)"
      required
    />
    <input-date
      :label="$t('targets.start_date')"
      @update-value="updateForm('start', $event)"
      required
      :min="new Date()"
      :value="formData.start"
    />
    <input-date
      :label="$t('targets.end_date')"
      @update-value="updateForm('end', $event)"
      required
      :min="new Date()"
      :value="formData.end"
    />
    <div class="text-right">
      <wd-button @input="submit(retryFormOptions)">{{ $t('targets.retry') }}</wd-button>
    </div>
  </div>
</template>

<script>
const Activity = require("@/modules/activities/components/Activity.vue")
  .default;
const InputText = require("@/modules/input/components/InputText.vue").default;
const InputDate = require("@/modules/input/components/InputDate.vue").default;
const InputCheck = require("@/modules/input/components/InputCheck.vue").default;
const Friend = require("@/modules/users/components/Friend.vue").default;
const FriendsSite = require("@/modules/users/components/FriendsSite.vue")
  .default;
const Info = require("@/modules/core/components/Info.vue").default;

import { Activity as ActivityModel } from "@/modules/activities/viewmodels/Activity";
import { ActivityCategory } from "@/modules/activities/viewmodels/ActivityCategory";

import FormMixin from "@/mixins/FormMixin";
import DateMixin from "@/mixins/DateMixin";
import _ from "lodash";

export default {
  name: "TargetCreateSite",
  mixins: [FormMixin, DateMixin],
  data() {
    return {
      activityCategories: [],
      foundActivities: [],
      selectedActivity: null,
      sentOnce: false
    };
  },
  props: {
    id: {
      type: String,
      default: null,
      required: true
    }
  },
  components: {
    InputText,
    InputDate
  },
  methods: {
    updateHeader() {
      this.$store.dispatch("header/update", {
        backbutton: true,
        clear: true,
        elements: [
          {
            value: this.$t("targets.retry_target")
          }
        ]
      });
    }
  },
  computed: {},
  async created() {
    this.activityCategories = await this.$store.getters[
      "activitycategory/api"
    ].GetAll();

    this.formData.start = this.momentTodayDatePicker();

    // Formoptions for retry form
    this.retryFormOptions = {
      async: true,
      custom: true,
      type: "target",
      call: "retry",
      id: this.id,
      action: response => {
        this.goTo("/targets");
        this.popup({
          title: this.$t("targets.target_restarted"),
          text: this.$t("targets.target_restarted_message")
        });
      }
    };

    this.updateHeader();
    this.loaded();
  }
};
</script>
